export default "__VITE_ASSET__BrKhlxGb__"